export const AdminPanelStyle = theme => ({
    /**
     * modified ag grid default theme
     */
  
    agThemeModified: {
      height: '100%'
    },
});  